import { render } from "./BankingDetails.vue?vue&type=template&id=7f5f667c&scoped=true"
import script from "./BankingDetails.vue?vue&type=script&lang=js"
export * from "./BankingDetails.vue?vue&type=script&lang=js"

import "./BankingDetails.vue?vue&type=style&index=0&id=7f5f667c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5f667c"]])

export default __exports__